export const set = (key: string, value: any) => {
  // @ts-ignore
  localStorage.setItem(key, JSON.stringify(value));
}

export const get = (key: string) => {
  // @ts-ignore
  return JSON.parse(localStorage.getItem(key) || null);
}

export const remove = (key: string) => {
  // @ts-ignore
  localStorage.removeItem(key);
}

export const removeKeys = (keys: string[]) => {
  keys.forEach((key) => {
    // @ts-ignore
    localStorage.removeItem(key);
  })
}

export default {
  set,
  get,
  remove,
  removeKeys
};